import React from "react";
import "./onboarding.css";

/**
 * Coquille commune aux écrans d'onboarding « lieu d'utilisation »
 * (design : Onboarding 01, 02a, 02b/c) : barre supérieure avec retour,
 * wordmark et jauge d'étapes, puis le contenu centré sur fond app.
 *
 * Les mêmes écrans servent hors onboarding — « ajouter une adresse »
 * depuis le menu — d'où `steps` optionnel : sans lui, pas de jauge.
 */

/** Sprite SVG des icônes du design, déclaré une fois par écran. */
export const OnboardingIcons = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <symbol id="ob-home" viewBox="0 0 512 512">
        <path
          d="M80,212V448a16,16,0,0,0,16,16h96V328a24,24,0,0,1,24-24h80a24,24,0,0,1,24,24V464h96a16,16,0,0,0,16-16V212"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <path
          d="M480,256,266.89,52c-5-5.28-16.69-5.34-21.78,0L32,256"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <polyline
          points="400 179 400 64 352 64 352 133"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="ob-business" viewBox="0 0 512 512">
        <rect
          x="32"
          y="128"
          width="448"
          height="320"
          rx="48"
          ry="48"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <path
          d="M144,128V96a32,32,0,0,1,32-32H336a32,32,0,0,1,32,32v32"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <line
          x1="480"
          y1="240"
          x2="32"
          y2="240"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <path
          d="M320,240v24a8,8,0,0,1-8,8H200a8,8,0,0,1-8-8V240"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="ob-check" viewBox="0 0 512 512">
        <polyline
          points="416 128 192 384 96 288"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "44px",
          }}
        />
      </symbol>
      <symbol id="ob-arrow-back" viewBox="0 0 512 512">
        <polyline
          points="244 400 100 256 244 112"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48px",
          }}
        />
        <line
          x1="120"
          y1="256"
          x2="412"
          y2="256"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48px",
          }}
        />
      </symbol>
      <symbol id="ob-location" viewBox="0 0 512 512">
        <path
          d="M256,48c-79.5,0-144,61.39-144,137,0,87,96,224.87,131.25,272.49a15.77,15.77,0,0,0,25.5,0C304,409.89,400,272.07,400,185,400,109.39,335.5,48,256,48Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <circle
          cx="256"
          cy="192"
          r="48"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="ob-search" viewBox="0 0 512 512">
        <path
          d="M221.09,64A157.09,157.09,0,1,0,378.18,221.09,157.1,157.1,0,0,0,221.09,64Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeMiterlimit: 10,
            strokeWidth: "32px",
          }}
        />
        <line
          x1="338.29"
          y1="338.29"
          x2="448"
          y2="448"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="ob-chat" viewBox="0 0 512 512">
        <path
          d="M408,64H104a56.16,56.16,0,0,0-56,56V312a56.16,56.16,0,0,0,56,56h40v80l93.72-78.14a8,8,0,0,1,5.13-1.86H408a56.16,56.16,0,0,0,56-56V120A56.16,56.16,0,0,0,408,64Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="ob-people" viewBox="0 0 512 512">
        <path
          d="M402,168c-2.93,40.67-33.1,72-66,72s-63.12-31.32-66-72c-3-42.31,26.37-72,66-72S405,126.46,402,168Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <path
          d="M336,304c-65.17,0-127.84,32.37-143.54,95.41-2.08,8.34,3.15,16.59,11.72,16.59H467.83c8.57,0,13.77-8.25,11.72-16.59C463.85,335.36,401.18,304,336,304Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeMiterlimit: 10,
            strokeWidth: "32px",
          }}
        />
        <path
          d="M200,185.94C197.66,218.42,173.28,244,147,244S96.3,218.43,94,185.94C91.61,152.15,115.34,128,147,128S202.39,152.77,200,185.94Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <path
          d="M206,306c-18.05-8.27-37.93-11.45-59-11.45-52,0-102.1,25.85-114.65,76.2C30.7,377.41,34.88,384,41.72,384H154"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="ob-help" viewBox="0 0 512 512">
        <path
          d="M256,80A176,176,0,1,0,432,256,176,176,0,0,0,256,80Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeMiterlimit: 10,
            strokeWidth: "32px",
          }}
        />
        <path
          d="M200,202.29s.84-17.5,19.57-32.57C230.68,160.77,244,158.18,256,158c10.93-.14,20.69,1.67,26.53,4.45,10,4.76,29.47,16.38,29.47,41.09,0,26-17,37.81-36.37,50.8S251,281.43,251,296"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: "28px",
          }}
        />
        <circle cx="250" cy="348" r="20" style={{ fill: "currentColor" }} />
      </symbol>
      <symbol id="ob-chevron-down" viewBox="0 0 512 512">
        <polyline
          points="112 184 256 328 400 184"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48px",
          }}
        />
      </symbol>
    </defs>
  </svg>
);

/** Icône du sprite, dimensionnée par la CSS du contexte. */
export const Icon = ({ name, ...rest }) => (
  <svg viewBox="0 0 512 512" aria-hidden="true" {...rest}>
    <use href={`#ob-${name}`} />
  </svg>
);

/**
 * @param {function} onBack  Retour ; sans lui, pas de bouton retour.
 * @param {object}   steps   { current, total } — jauge d'étapes, optionnelle.
 * @param {boolean}  top     Contenu aligné en haut plutôt que centré.
 */
const OnboardingLayout = ({ onBack, steps, top = false, children }) => (
  <div className="wosh-ob">
    <OnboardingIcons />

    <header className="wosh-ob__bar">
      <div className="wosh-ob__brand">
        {onBack && (
          <button type="button" className="wosh-ob__back" onClick={onBack}>
            <Icon name="arrow-back" />
          </button>
        )}
        <div className="wosh-ob__wordmark">WOSH</div>
      </div>

      {steps ? (
        <div className="wosh-ob__progress">
          <div className="wosh-ob__segments">
            {Array.from({ length: steps.total }, (_, index) => (
              <span key={index} className={index < steps.current ? "is-done" : ""} />
            ))}
          </div>
          <div className="wosh-ob__step">
            {steps.current}/{steps.total}
          </div>
        </div>
      ) : (
        <div />
      )}

      <div />
    </header>

    <main className={`wosh-ob__main${top ? " wosh-ob__main--top" : ""}`}>
      {children}
    </main>
  </div>
);

export default OnboardingLayout;
